export const locale = {
    lang: 'tr',
    data: {
      'EDITOR': {
        'CARGANDO': 'Bilgi yükleniyor',
        'GUARDANDO': 'Değişiklikleri kaydediyor',
        'ELEMENTOS': {
          'GUIA': 'Bu bloğun elemanları',
          'COLORES': {
            'ORIGINAL': 'Değiştirilmemiş öğe',
            'MODIFICADO': 'Değiştirilmiş öğe'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Hiçbir öğe değiştirilmedi',
            'MODIFICADO': 'Bir veya daha fazla öğe değiştirildi',
            'COMPLETO': 'Tüm öğeler değiştirildi',
            'AMPLIAR': 'Büyük boyda görüntüle',
            'ELIMINAR': 'Bu resmi sil',
            'IMPORTAR': 'Bu öğeyi başka bir dilden içe aktarın',
            'CONFIGDOMINIO': 'Arka uç alan yapılandırması',
            'COPIARURL': 'Bağlantıyı kopyala'
          },
          'ETIQUETAS': {
            'INTERFAZ': {
              'TITULO': 'Aracıya göre yapılandırma',
              'SUBTITULO': 'Mevcut her bir komisyoncunun ayarlarını görüntüleyebilir ve değiştirebilirsiniz.',
              'PASOINICIAL': 'Yapılandırmasını göstermek için listeden bir komisyoncu seçin',
              'SELBROKER': 'Seçilen komisyoncu',
              'SELOPC': 'Seçili seçenek',
              'SINJSONS': 'Bu komisyoncudan bilgi yüklenemedi, lütfen daha sonra deneyin',
              'DOMINIO': {
                'TITULO': 'Aracı arka uç alan yapılandırması',
                'ACTIVAR': 'Aracı ile ilişkili etki alanını etkinleştirin',
                'DOMINIO': 'Aracı ile ilişkili alan adı'
              },
              'MODAL': {
                'TITULO': 'Öğeyi içe aktar',
                'SUBTITULO': 'Bu öğeyi içe aktarmak istediğiniz dili seçin'
              }
            },
            'IMAGEN': {
              'NOHAY': 'Görüntü yok',
              'ACTUAL': 'Geçerli resim'
            },
            'TEXTO': {
              'INGRESAR': 'Metninizi girin'
            },
            'VIDEO': {
              'NOVIDEO': 'Bir video yüklemediniz',
              'GUARDANDO': 'Video kaydediliyor, yükleme tamamlanana kadar bu ekrandan çıkmayın'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Anket özelliklerini düzenleyin',
            'REGRESAR': 'Geri gitmek',
            'CONTINUAR': 'Devam et',
            'CANCELAR': 'İptal etmek',
            'GUARDAR': 'Değişiklikleri Kaydet',
            'IMAGEN': 'Resmi değiştir',
            'EDITOR': 'Mesajı düzenleyin',
            'ELEMENTOS': 'Yardım',
            'ACTIVAR': 'Göstermek',
            'DESACTIVAR': 'Saklamak',
            'VERVIDEO': 'Video izle',
            'CARGARVIDEO': 'Video dosyası yükle',
            'OTROVIDEO': 'Başka bir video dosyası yükle',
            'SI': 'Evet',
            'NO': 'Hayır',
            'INFO': 'Önemli',
            'ADDIMG': 'Resim eklemek'
          },
          'MODALIMAGEN': {
            'TITULO': 'mesaja resim ekle',
            'TABS': {
              'INSTRUCCIONES': {
                'TITULO': 'Talimatlar',
                'PASO_1': '\'Görüntüler\' sekmesine tıklayın, orada önceden yüklenmiş bir resim seçebilir veya yeni bir resim de yükleyebilirsiniz.',
                'PASO_2': 'Halihazırda yüklenmiş bir resmi seçmek istiyorsanız, imleci istediğiniz resmin üzerine getirerek iki işlem gerçekleştirebilirsiniz: Resmi görüntüleyin veya bağlantıyı kopyalayın',
                'PASO_2_1': 'Önizlemek için, aşağıdaki simgeye sahip görüntünün üzerindeki düğmeyi tıklayın',
                'PASO_2_2': 'Bağlantıyı kopyalamak için aşağıdaki simgeye sahip görselin üzerindeki butona tıklayın',
                'PASO_3': 'Yeni bir resim yüklemek istiyorsanız, aşağıdaki simgenin bulunduğu butona tıklayın.',
                'PASO_4': 'Resmi yüklemeyi tamamladığınızda, bağlantısını otomatik olarak alacaksınız',
                'PASO_5': 'Mesaj düzenleyiciye geri dönün ve aşağıdaki simgeyle bir resim eklemek için düğmeye tıklayın',
                'PASO_6': 'Açılır pencerede kopyalanan bağlantıyı yerleştirin ve piksel cinsinden ifade edilen görüntü boyutunu ayarlayın. Bitirdiğinizde, Kaydet düğmesini tıklayın. Açılır pencere kapanacak ve resim, ayarlanan boyutta düzenleyiciye yerleştirilecektir.'
              },
              'IMAGENES': {
                'TITULO': 'Görüntüler',
                'CARGANDO': 'Mevcut resimler yükleniyor',
                'NOTA': '* Burada gösterilen resimler dosya yöneticisine kaydedilir.',
                'TITULO_2': 'Kullanılabilir resimler',
                'ADD': 'Yeni bir resim ekle',
                'NOIMG': 'Resim yok',
                'URLCOPIADA': 'Resim bağlantısı panoya kopyalandı',
                'OKBOT': 'Tamam mı'
              },
            }
          }
        },
        'CATALOGOS': {
          'temas': {
            'temaFocusArea2': 'Renk seti 1',
            'theme-temaIzzi': 'Renk seti 2',
            'theme-blue-gray-dark': 'Renk seti 3',
            'theme-pink-dark': 'Renk seti 4',
            'theme-temaIzzi-2': 'Renk seti 5',
            'theme-temaItbm': 'Renk seti 6',
          },
          'numColumnas': {
            '1': '1 sütun',
            '4': '4 sütun',
            '5': '5 sütun',
          },
          'segundos': {
            '1000': '1 saniye',
            '2000': '2 saniye',
            '3000': '3 saniye',
            '4000': '4 saniye',
            '5000': '5 saniye',
            '6000': '6 saniye',
            '7000': '7 saniye',
            '8000': '8 saniye',
            '9000': '9 saniye',
            '10000': '10 saniye',
            '11000': '11 saniye',
            '12000': '12 saniye',
            '13000': '13 saniye',
            '14000': '14 saniye',
            '15000': '15 saniye',
            '16000': '16 saniye',
            '17000': '17 saniye',
            '18000': '18 saniye',
            '19000': '19 saniye',
            '20000': '20 saniye',
          },
          'logosIniciales': {
            '0': 'CulturalGO logosu'
          }
        },
        'ADVERTENCIAS': {
          'URLEXTERNA': 'Uyarı: Kaynak site harici sitelerden sayfaya erişime izin vermiyorsa, içerik görüntülenmeyecektir',
          'TEMPLATEFALTANTE': 'Uyarı: Bu şablon bu dil için mevcut değil',
          'CONFIGURACION': {
            'ACTIVAR': 'Dikkat: Özel yapılandırmayı etkinleştirirken, bu ekranda belirtilen tüm öğeler platform arayüzüne yerleştirilecektir, tüm doğru öğeleri yerleştirdiğinizden emin olun \n\n Özel yapılandırmaya devam etmek ve etkinleştirmek istiyor musunuz?',
            'DESACTIVAR': 'Dikkat: Özel yapılandırmayı devre dışı bırakırken, bu aracı için ve ona ait olan tüm kullanıcılar için platformda oluşturulan varsayılan öğeler yerleştirilecektir. \n\n Kişiselleştirilmiş yapılandırmaya devam etmek ve devre dışı bırakmak istiyor musunuz? '
          },
          'PRIORIDAD': {
            '1': 'Bu öğe aktifse, öncelik arka plan resimlerine göre verilecektir.',
            '2': 'Bu öğe etkinse, öncelik arka plan görüntüleri ve video arka planı üzerinde verilecektir.'
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Oturum aç',
            'PASOS': {
              'VARIOS': {
                'TITULO': 'Karışık objeler',
                'ELEMENTOS': {
                  'images_broker': 'Broker logosu',
                  'title': 'Ana başlık',
                  'images_login': 'Sistem logosu',
                  'images_logout': 'Oturum kapatılırken görüntülenen resim',
                  'changeTime': 'Görüntüler arasındaki zaman aralığı'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Arka plan resimleri',
                'ELEMENTOS': {
                  'agregar': 'Bir resim ekleyin',
                  'importar': 'Diğer ayarlardan görüntüleri içe aktarın',
                }
              },
              'VIDEO': {
                'TITULO': 'Arka plan videosu',
                'ELEMENTOS': {
                  'enable': 'Arka plan videosunu etkinleştir',
                  'video': 'Gösterilecek video',
                  'loop': 'Otomatik tekrarı etkinleştir',
                  'mute': 'Sesi kapatılmış videoyu göster'
                }
              },
              'EXTERNO': {
                'TITULO': 'Harici içerik',
                'ELEMENTOS': {
                  'enable': 'Harici içeriği etkinleştirin',
                  'url': 'Görüntülenecek harici içeriğin bağlantısı',
                }
              }
            }
          },
          'HOME': {
            'TITULO': 'Ana Sayfa',
            'PASOS': {
              'BRAND':{
                'TITULO': 'Yan menüde sistem kimliği',
                'ELEMENTOS': {
                  'logo': 'Sistem logosu',
                  'name': 'Sistem adı'
                }
              },
              'LOGOINICIAL': {
                'TITULO': 'İlk logo',
                'ELEMENTOS': {
                  'show': 'İlk sistem logosunu göster',
                  'time': 'Logo görüntüleme süresi (saniye cinsinden ifade edilir)',
                  'type': 'Görüntülenecek ilk logo türü'
                }
              },
              'MOSAICO': {
                'TITULO': 'Görüntülerin mozaiği',
                'ELEMENTOS': {
                  'branding_show': 'Sistem marka logosunu göster',
                  'branding_image': 'Sistem marka logosu',
                  'grayFilter': 'Başlangıç görüntülerinde gri filtre',
                  'bgGridColumns': 'Görüntülenecek resim sütunlarının sayısı'
                }
              },
              'TEMAS': {
                'TITULO': 'Platform renk teması',
                'ELEMENTOS': {
                  'theme': 'Sistemde görüntülenecek renk teması'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Arka plan resimleri',
                'ELEMENTOS': {
                  'agregar': 'Bir resim ekleyin',
                  'importar': 'Diğer ayarlardan görüntüleri içe aktarın',
                }
              },
              'VIDEO': {
                'TITULO': 'Arka plan videosu',
                'ELEMENTOS': {
                  'enable': 'Arka plan videosunu etkinleştir',
                  'video': 'Gösterilecek video',
                  'loop': 'Otomatik tekrarı etkinleştir',
                  'mute': 'Sesi kapatılmış videoyu göster'
                }
              },
              'EXTERNO': {
                'TITULO': 'Harici içerik',
                'ELEMENTOS': {
                  'enable': 'Harici içeriği etkinleştirin',
                  'url': 'Görüntülenecek harici içeriğin bağlantısı',
                }
              },
              'LOADER': {
                'TITULO': 'Resim .gif yükleniyor',
                'ELEMENTOS': {
                  'image': 'Resim yükleniyor .gif',
                  'GUARDANDO': 'Görüntü kaydediliyor, yükleme tamamlanana kadar bu ekrandan çıkmayın'    
                }
              },
            }
          },
          'TEMPLATES': {
            'TITULO': 'E-posta Şablonları',
            'PASOS': {
              'RT_1': {
                'TITULO': 'Yeni bir ürünü kaydederken gönderilen teknik gereksinimler',
                'ELEMENTOS': {
                  'asunto': 'Mesaj Konusu',
                  'mensaje': 'Mesaj gövdesi'
                }
              },
              'RT_2': {
                'TITULO': 'Teknik gereksinimler, doğrulama sırasında gönderilen demo mesajı',
                'ELEMENTOS': {
                  'asunto': 'Mesaj Konusu',
                  'mensaje': 'Mesaj gövdesi'
                }
              },
              'PASS_3': {
                'TITULO': 'Kullanıcı şifresi güncellenirken gönderilen posta',
                'ELEMENTOS': {
                  'asunto': 'Mesaj Konusu',
                  'mensaje': 'Mesaj gövdesi'
                }
              },
              'PASS_4': {
                'TITULO': 'Kullanıcı profilini güncellerken e-posta gönderildi',
                'ELEMENTOS': {
                  'asunto': 'Mesaj Konusu',
                  'mensaje': 'Mesaj gövdesi'
                }
              },
              'GETMYCODE_6': {
                'TITULO': 'GetMyCode ile gönderilen posta',
                'ELEMENTOS': {
                  'asunto': 'Mesaj Konusu',
                  'mensaje': 'Mesaj gövdesi'
                }
              },
              'RT_7': {
                'TITULO': 'Teknik gereksinimlerin kabulü için posta',
                'ELEMENTOS': {
                  'asunto': 'Mesaj Konusu',
                  'mensaje': 'Mesaj gövdesi'
                }
              },
            }
          }
        }
      }
    }
};
